var _style, _rect, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "350px",
    height: "650px",
    viewBox: "0 0 350 650",
    style: {
      enableBackground: "new 0 0 350 650"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.1;fill:#00386E;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:none;stroke:#004666;}\n\t.st3{fill:#00386E;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 350,
    height: 650
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 172,
    cy: 314,
    r: 65
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 118.5,
    cy: 200.5,
    r: 17
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 216,
    cy: 496,
    r: 14.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 240.5,
    cy: 465.5,
    r: 32
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 239.5,
    cy: 98.5,
    r: 10.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 92,
    cy: 533,
    r: 35
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 172,
    cy: 314,
    r: 70.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M159.88,299.01c-0.22,0.8-1.05,1.27-1.85,1.05c-0.8-0.22-1.27-1.05-1.05-1.85c1.82-6.58,7.9-11.19,14.98-11.19 c8.56,0,15.07,6.21,15.07,15.04c0,3.98-1.9,8.05-4.87,10.74c-1.29,1.16-3.45,2.64-6.51,4.47c-2.27,1.35-3.65,3.8-3.65,6.44V326 c0,0.83-0.67,1.5-1.5,1.5s-1.5-0.67-1.5-1.5v-2.29c0-3.7,1.94-7.12,5.12-9.01c2.91-1.74,4.93-3.12,6.04-4.12 c2.35-2.13,3.88-5.4,3.88-8.51c0-7.14-5.13-12.04-12.07-12.04C166.23,290.02,161.33,293.73,159.88,299.01z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M170.5,339.5c-1.66,0-3-1.34-3-3s1.34-3,3-3s3,1.34,3,3S172.16,339.5,170.5,339.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntro);
export default __webpack_public_path__ + "static/media/intro.8320fc4f9ca0f2a49f8913dc6d626229.svg";
export { ForwardRef as ReactComponent };